<div class="page-header-container left-wrapper flex-utility align-center">
  <div class="filters-label">{{ 'PAGES.FILTER.TITLE' | translate }}:</div>
  <form #formRef class="row" [class.expanded]="showMoreFilters" (ngSubmit)="apply()">
    <!-- FULL TEXT -->
    <ng-container>
      <input matInput class="input-form" id="full-text-search" type="search" [formControl]="searchFormControl"
        [placeholder]="placeholderSearch | translate">
    </ng-container>

    <!-- SELECT -->
    <mat-form-field *ngIf="showcases" class="showcase-select-field">
      <mat-select [placeholder]="'PAGES.ALLOCATION.PLACEHOLDERS.SEARCH_SHOWCASE' | translate"
        [formControl]="showCaseControl">
        <mat-option [value]=""> </mat-option>
        <mat-option *ngFor="let showcase of showcases" [value]="showcase.code">
          <p class="text-value"> {{ translateSelectShowcase(showcase) }} </p>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="select-field">
      <mat-select [placeholder]="'PAGES.DASHBOARD.PLACEHOLDERS.SEARCH_STATUS' | translate"
        [formControl]="statusFormControl">
        <mat-option [value]=""> </mat-option>
        <mat-option *ngFor="let status of selectStatus" [value]="status.toString()">
          <p class="text-value"> {{ sharedService.translateStatusText(status) }} </p>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="select-field">
      <mat-select [placeholder]="'PAGES.DASHBOARD.PLACEHOLDERS.SEARCH_SALE_ROOMS' | translate"
        [formControl]="roomsFormControl">
        <mat-option [value]=""> </mat-option>
        <mat-option *ngFor="let sr of selectSalesRooms" [value]="sr">
          <p class="text-value"> {{getValueSalesRoom(sr)}} </p>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="select-field">
      <mat-select [placeholder]="'PAGES.DASHBOARD.PLACEHOLDERS.SEARCH_APPOINTMENT_STATUS' | translate"
        [formControl]="appointmentFormControl">
        <mat-option [value]=""> </mat-option>
        <mat-option *ngFor="let status of appointmentStatus" [value]="status.toString()">
          <p class="text-value"> {{ sharedService.translateAppointmentStatus(status) }} </p>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="select-field">
      <mat-select [placeholder]="'PAGES.DASHBOARD.PLACEHOLDERS.BFS' | translate" [formControl]="isBookedForSalesControl">
        <mat-option [value]=""> </mat-option>
        <mat-option [value]="true">
          <p class="text-value"> {{ 'PAGES.DASHOBOARD.BFS_VALUE.0' | translate }} </p>
        </mat-option>
        <mat-option [value]="false">
          <p class="text-value"> {{ 'PAGES.DASHOBOARD.BFS_VALUE.1' | translate }} </p>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>

  <div class="button-wrapper">
    <ng-container *ngIf="showMoreAndLessButtons">
      <app-bulgari-button *ngIf="showMoreFilters" [type]="'flat'" (click)="showFilters(false)"
        [customStyle]="'text-transform: capitalize;'" [text]="'PAGES.FILTER.SHOW_LESS'"></app-bulgari-button>
      <app-bulgari-button *ngIf="!showMoreFilters" [type]="'flat'" (click)="showFilters(true)"
        [customStyle]="'text-transform: capitalize;'" [text]="'PAGES.FILTER.SHOW_MORE'"></app-bulgari-button>
    </ng-container>
    <app-bulgari-button [type]="'primary'" (click)="apply()" [customStyle]="'text-transform: capitalize;'"
      [text]="'PAGES.FILTER.APPLY'"></app-bulgari-button>
    <app-bulgari-button [type]="'flat'" (click)="reset()"
      [customStyle]="'background: transparent; border: none; text-decoration: underline; text-transform: uppercase; padding: 0 !important;'"
      [text]="'PAGES.FILTER.RESET_FILTER'"></app-bulgari-button>
  </div>
</div>
